import { render, staticRenderFns } from "./BusinessApplicationAdd.vue?vue&type=template&id=ccb36fc8&"
import script from "./BusinessApplicationAdd.vue?vue&type=script&lang=js&"
export * from "./BusinessApplicationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports